export function authHeader() {
  // return authorization header with jwt token
  let user = localStorage.getItem("token");
  if (user && user) {
    return { Authorization: "Bearer " + user };
  } else {
    return {};
  }
}
